export type TSectionTitleLevel = 2 | 3 | 4;

export enum SectionTitleModes {
  DEFAULT = 'default',
  BACKGROUND = 'background',
}

export type TSectionTitleConfig = {
  text: string;
  tooltipContent?: string;
  level?: TSectionTitleLevel;
  mode?: SectionTitleModes;
};
